import * as yup from 'yup';

import { FORM_INPUT_ERROR_MSGS } from '../../../../../../../constants/errors';
import { msisdnValidationSimple, reportToDate } from '../../../../../../../constants/validation';

export const filtersValidationSchema = yup.object().shape({
  from: yup
    .date()
    .required(FORM_INPUT_ERROR_MSGS.REQUIRED('starting date'))
    .typeError(FORM_INPUT_ERROR_MSGS.INVALID_FORMAT('starting date')),
  to: reportToDate,
  msisdns: yup.array(msisdnValidationSimple)
});
